import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { validateToken } from '../Accounts/API'
import Form from './Form'

export default () => {
    const [tokenChecked, setTokenChecked] = useState(false)
    const [tokenError, setTokenError] = useState(false)
    const [networkError, setNetworkError] = useState(false)
    const token = useSearchParams()[0].get('token')

    useEffect(() => {
        validateToken(token)
            .catch(err => {
                if (err.response.data.detail === 'Not found.') {
                    return setTokenError(true)
                }
                setNetworkError(true)
            })
            .finally(() => {
                setTokenChecked(true)
            })
    }, [])

    let pageContent = <Form token={token} />

    if (!tokenChecked) {
        pageContent = <p>Loading...</p>
    }
    if (tokenError) {
        pageContent = (
            <p>
                The password link you have followed has expired or is invalid. You must create a new link or a new
                account.
            </p>
        )
    }
    if (networkError) {
        pageContent = <p>There was an error verifying your account. Please try again later.</p>
    }

    return pageContent
}
